<mat-accordion>
  <mat-expansion-panel class="filters"
                       [expanded]="shouldExpand">
    <mat-expansion-panel-header class="filters-header">
      <mat-panel-title>
        {{title | translate}}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-container>
      <ng-content></ng-content>
    </ng-container>
  </mat-expansion-panel>

</mat-accordion>
